import { ref, onMounted, computed } from 'vue'
import { useEventListener } from '@vueuse/core'

export function useSizeBreakpoint() {
	const breakpoint = ref(null)

	function widthToBreakpoint(width) {
		if (width >= 1400) {
			return 'xxl'
		} else if (width >= 1200) {
			return 'xl'
		} else if (width >= 992) {
			return 'lg'
		} else if (width >= 768) {
			return 'md'
		} else if (width >= 576) {
			return 'sm'
		} else if (width < 576) {
			return 'None'
		} else {
			return 'null'
		}
	}

	const isDesktop = computed(() => ['lg', 'xl', 'xxl'].includes(breakpoint.value))
	const isMobile = computed(() => !isDesktop.value)
	
	onMounted(() => {
		breakpoint.value = widthToBreakpoint(
			Number(document.documentElement.clientWidth)
		)
	})

	useEventListener(window, 'resize', () => {
		breakpoint.value = widthToBreakpoint(
			Number(document.documentElement.clientWidth)
		)
	})

	return { breakpoint, isDesktop, isMobile, }
}